import * as _ from 'underscore';

import StringField from '../../../../_common/platform/ts/StringField';

import BooleanField from '../../../../_common/platform/ts/BooleanField';

import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { GISPositionField } from '../../ts/GISPositionField';
import { GISMapField } from '../../ts/GISMapField';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import * as Config from '../config';

declare var require: any;

var template = require('!!raw-loader!pdc-widget-gis/src/mainTheme.template.css').default;

import { ThemePreview } from '../../tsx/ThemePreview';

template;

declare var Color: any;
declare var pdc: any;

var _init = [];
var self = this;

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }
    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: Config.themeId, //'widget-gis',
            name: 'GIS',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-gis',

            themeType: 'Widget Gis',
            visibility: ['application', 'workspace', 'pdc-widget-gis']
        }
    ]);

    appTheme.registerVars([
        {
            id: 'widget-gis-google-api-key',
            param: new StringField(glob, 'Google Map API Key', [], ''),
            section: 'widget-gis'
        },
        {
            id: 'widget-gis-show-layers',
            param: new BooleanField(glob, 'Show Layers Selector', [], true),
            section: 'widget-gis'
        },
        {
            id: 'widget-gis-position',
            param: new GISPositionField(glob, '', [], {
                center: 'CenterToContent',
                zoom: 5,
                latitude: 41.89051,
                longitude: 12.49424
            }),
            section: 'widget-gis'
        },
        {
            id: 'widget-gis-map',
            param: new GISMapField(glob, '', [], {
                GIS_service: 'OpenStreetMap',
                water_color: 'transparent',
                landscape_color: 'transparent'
            }),
            section: 'widget-gis'
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-gis']);

    _init.push(glob);
}
